import React, { useState } from 'react';
import { Title, useTranslate } from 'react-admin';
import { useNavigate } from 'react-router-dom';
import LearningPathList from './LearningPathList';
import LearningPathDetail from './LearningPathDetail';
import './learning-paths-design.css';

/**
 * Lernpfade-Seite (/learning-paths) im Design-System-Look.
 * Die App-Shell (AppBar/Drawer/BottomNav) und die Seiten-<h1> kommen aus
 * Layout.tsx (.page + TitleBar) — hier wird nur der Seiteninhalt gerendert.
 */
const LearningPathsPage: React.FC = () => {
    const translate = useTranslate();
    const navigate = useNavigate();
    const [tabValue, setTabValue] = useState(0);
    const [selectedPathId, setSelectedPathId] = useState<number | null>(null);

    const handlePathSelect = (pathId: number) => {
        setSelectedPathId(pathId);
    };

    const handleBack = () => {
        setSelectedPathId(null);
    };

    const handleCourseSelect = (courseId: number) => {
        navigate(`/course-player/${courseId}`);
    };

    if (selectedPathId) {
        return (
            <div className="oa-learning-paths">
                <Title title={translate('learningPaths.title', { _: 'Lernpfade' })} />
                <LearningPathDetail
                    pathId={selectedPathId}
                    onBack={handleBack}
                    onCourseSelect={handleCourseSelect}
                />
            </div>
        );
    }

    return (
        <div className="oa-learning-paths">
            <Title title={translate('learningPaths.title', { _: 'Lernpfade' })} />

            <p className="lp-sub">Strukturierte Kursfolgen — vom Einstieg bis zur Spezialisierung.</p>

            <div className="ktabs" role="tablist">
                <button
                    type="button"
                    role="tab"
                    aria-selected={tabValue === 0}
                    className={`ktab${tabValue === 0 ? ' active' : ''}`}
                    onClick={() => setTabValue(0)}
                >
                    {translate('learningPaths.allPaths', { _: 'Alle Lernpfade' })}
                </button>
                <button
                    type="button"
                    role="tab"
                    aria-selected={tabValue === 1}
                    className={`ktab${tabValue === 1 ? ' active' : ''}`}
                    onClick={() => setTabValue(1)}
                >
                    {translate('learningPaths.myPaths', { _: 'Meine Lernpfade' })}
                </button>
            </div>

            {tabValue === 0 ? (
                <LearningPathList onPathSelect={handlePathSelect} />
            ) : (
                <LearningPathList onPathSelect={handlePathSelect} showOnlyEnrolled />
            )}
        </div>
    );
};

export default LearningPathsPage;
